// extracted by mini-css-extract-plugin
module.exports = {"Project":"Project_Project__Dc91d","video":"Project_video__G3I9t","image":"Project_image__jwUwk"};